module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proxyValue),
      expression: "proxyValue"
    }],
    staticClass: "form-control",
    class: {
      errors: _vm.isErrors
    },
    attrs: {
      "type": "number",
      "id": _vm.name,
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.proxyValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proxyValue = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isErrors) ? _c('ul', {
    staticClass: "error-placeholder"
  }, _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b870f90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/NumberInput.vue
// module id = 1283
// module chunks = 2